import { useState, useEffect } from 'react';
import { DAV_APIS } from '../adapters';

let accommodationsData: any[] = [];

const useAccommodations = (refresh?: number | null) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [accommodations, setAccommodations] = useState<any[]>([]);

  useEffect(() => {
    const fetchAccommodations = async () => {
      if (!navigator.onLine) return;
      if (accommodationsData.length > 0 && !refresh) {
        setAccommodations(accommodationsData);
        return;
      }
      setLoading(true);
      try {
        const res = await DAV_APIS.accommodation.get.getAllAccommodations();
        setAccommodations(res.data.accommodations);
        accommodationsData = res.data.accommodations;
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    fetchAccommodations();
  }, [refresh]);

  return {
    loading,
    accommodations,
  };
};

export default useAccommodations;
